import {Component, Input, ViewChild} from '@angular/core';
import {AddressInfoCardComponent} from "../address-info-card/address-info-card.component";
import {ContactInfoCardComponent} from "../contact-info-card/contact-info-card.component";
import {EnrollmentModel} from "../../domain/models/enrollment.model";
import {EnrollmentComponent} from "../enrollment-request/EnrollmentComponent";

@Component({
  selector: 'app-enrollment-owner',
  standalone: true,
  imports: [
    AddressInfoCardComponent,
    ContactInfoCardComponent
  ],
  templateUrl: './enrollment-owner.component.html',
  styleUrl: './enrollment-owner.component.css'
})
export class EnrollmentOwnerComponent implements EnrollmentComponent {
  @Input() enrollment!: EnrollmentModel;
  @ViewChild(AddressInfoCardComponent) addressInfoCard!: AddressInfoCardComponent;
  @ViewChild(ContactInfoCardComponent) contactInfoCard!: ContactInfoCardComponent;

  getUpdatedEnrollment(): EnrollmentModel {
    const contactInfo = this.contactInfoCard.getContactInfoFromForm();
    const addressInfo = this.addressInfoCard.getAddressInfoFromForm();
    return {
      id: this.enrollment.id,
      ...contactInfo,
      ...addressInfo
    };
  }

  isFormValid(): boolean {
    return this.contactInfoCard.isFormValid() &&
      this.addressInfoCard.isFormValid();
  }

  raiseFormValidations(): void {
    this.addressInfoCard.getForm()?.markAllAsTouched();
    this.contactInfoCard.contactInfoForm.markAllAsTouched();
  }
}
